import Vue from 'vue'
import App from './App.vue'
import vuetify from '@/plugins/vuetify'
import VueMask from 'v-mask'
import Vuelidate from 'vuelidate'
import '@/assets/layouts/main.css'
import VueRouter from 'vue-router'
import router from './router'

Vue.config.productionTip = false

Vue.use(VueMask);
Vue.use(Vuelidate)
Vue.use(VueRouter)

export const eventBus = new Vue()

new Vue({
  vuetify,
  router,
  render: h => h(App),
}).$mount('#app')
